import { render, staticRenderFns } from "./spotCheck.vue?vue&type=template&id=b0c1a1f2&scoped=true&"
import script from "./spotCheck.vue?vue&type=script&lang=js&"
export * from "./spotCheck.vue?vue&type=script&lang=js&"
import style0 from "./spotCheck.vue?vue&type=style&index=0&id=b0c1a1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c1a1f2",
  null
  
)

export default component.exports